import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import { firstError, firstResponseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import Dialog from '@/components/dialogs/Dialog';
import {
  hideAddDatasetCollections,
  addDatasetCollections,
  removeDatasetCollectionAssignable,
  updateDatasetCollectionsAssignableProperties,
} from '../actions';
import DatasetCollectionsAssignTable from '../components/DatasetCollectionsAssignTable';
import DatasetCollectionAddRow from './DatasetCollectionAddRow';

const AssignDatasetCollectionsDialog = ({
  add,
  category,
  code,
  collectionsToAdd,
  hide,
  isDirty,
  name,
  readStatus,
  removeCollection,
  saveErrors,
  saveStatus,
  theme,
  updateProperties,
}) => {
  const intl = useIntl();
  const setErrors = (newErrors) => updateProperties({ saveErrors: newErrors });

  return (
    <Dialog
      className="aridhia-assign-dataset-collections-dialog smallwizard"
      error={firstResponseError(saveErrors)}
      icon="object group outline"
      inProgress={saveStatus === states.PENDING}
      minimumDataEntryMet={isDirty}
      onClose={() => hide(category, code)}
      onDismiss={() => setErrors([])}
      onSave={add}
      saveMessageId="actions.apply"
      size="small"
      theme={theme}
      title={intl.formatMessage({ id: 'dataset.collections.add.title' }, { name })}
    >
      <div className="aridhia-assign-dataset-collections-dialog-container">
        <DatasetCollectionsAssignTable
          category={category}
          code={code}
          readStatus={readStatus}
          error={firstError(saveErrors)}
          onErrorDismiss={() => setErrors([])}
          collections={collectionsToAdd}
          removeCollection={removeCollection}
        >
          <DatasetCollectionAddRow category={category} code={code} />
        </DatasetCollectionsAssignTable>
      </div>
    </Dialog>
  );
};

const dialogProps = ({
  category, code, saveStatus, saveErrors,
}, exists) => (
  {
    exists,
    category,
    code,
    saveStatus,
    saveErrors,
  }
);

const withoutItem = (datasetAssigningCollection) => (
  {
    ...dialogProps(datasetAssigningCollection, false),
    collectionsToAdd: [],
    isDirty: false,
    readStatus: states.NONE,
    readErrors: [],
  }
);

const withItem = (item, collectionAssigningDataset) => {
  const {
    readStatus, readErrors,
  } = collectionAssigningDataset;
  const isDirty = item.collectionsToAdd.results.length;

  return (
    {
      ...dialogProps(collectionAssigningDataset, true),
      collectionsToAdd: item.collectionsToAdd.results,
      name: item.name,
      isDirty,
      readStatus,
      readErrors,
    }
  );
};

const mapStateToProps = ({
  datasetCollections: {
    collectionAssigningDataset,
    datasetCollections,
  },
}) => {
  const item = findResult(datasetCollections, collectionAssigningDataset.category, collectionAssigningDataset.code);
  return item ? withItem(item, collectionAssigningDataset) : withoutItem(collectionAssigningDataset);
};

const mapDispatchToProps = {
  add: addDatasetCollections,
  hide: hideAddDatasetCollections,
  removeCollection: removeDatasetCollectionAssignable,
  updateProperties: updateDatasetCollectionsAssignableProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignDatasetCollectionsDialog);
